import {
  Box,
  Button,
  FormControlLabel,
  Grid,
  Switch,
  Typography,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { useContext } from "react";
// import { useGetNotificationPreferences } from "../../hooks/query/useTenantSettings";
import { AuthContext } from "../../context/authContext";
import { useChangeNotificationPreferences } from "../../hooks/query/useTenantSettings";
import { toast } from "react-toastify";

interface NotificationsState {
  email: boolean;
  pushNotification: boolean;
}
interface NotificationPreferencesProps {
  notificationPreferences?: {
    email?: boolean;
    pushNotification?: boolean;
  };
}

const NotificationPreferencesForm: React.FC<NotificationPreferencesProps> = ({
  notificationPreferences,
}) => {
  const { currentUser } = useContext(AuthContext);
  console.log("Current user", currentUser);

  // const { data: notificationPreferences, isLoading } =
  //   useGetNotificationPreferences(currentUser.tenant.id);
  // console.log(notificationPreferences);

  const { control, handleSubmit } = useForm<NotificationsState>({
    defaultValues: {
      email: notificationPreferences?.email,
      pushNotification: notificationPreferences?.pushNotification,
    },
  });

  const { mutate: changeNotificationPreferences } =
    useChangeNotificationPreferences();

  const onSubmit = (data: NotificationsState) => {
    const requestBody = {
      email: data.email,
      pushNotification: data.pushNotification,
    };

    changeNotificationPreferences(
      { tenantId: currentUser.tenant.id, requestBody },
      {
        onSuccess: () => {
          toast.success("Notification Preferences changed successfully");
          console.log("Notification preferences updated successfully");
        },
        onError: (error: any) => {
          toast.error(error?.body?.error?.message || "An error occurred");
          console.error("Error updating notification preferences:", error);
        },
      }
    );
  };

  return (
    <Box>
      <Typography variant="h5" color="primary" gutterBottom>
        Notification Preferences
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Switch {...field} checked={field.value} color="primary" />
                  }
                  label="Email Notifications"
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="pushNotification"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Switch {...field} checked={field.value} color="primary" />
                  }
                  label="Push Notifications"
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 2 }}
            >
              Save Notification Preferences
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default NotificationPreferencesForm;
